// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  width: 100%;
  padding: 0;
}

.chatbot-dislike-feedback-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
}

.feedback-flag-selection {
  display: flex;
  flex-flow: column;
  width: 100%;
  background-color: var(--ion-color-tertiary);
  overflow-y: scroll;
  overflow-x: hidden;
  flex-grow: 1;
  padding: var(--d-spacing-single) var(--d-spacing-double) 0 var(--d-spacing-double);
}

.feedback-dislike-buttons {
  padding: var(--d-spacing-double);
  padding-top: var(--d-spacing-single);
  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.25);
  z-index: 10000;
}

.feedback-header-content {
  min-height: calc(var(--d-spacing-double) * 2.5);
  width: 100%;
  margin: 0;
  background-color: white;
}

.feedback-header-content-container {
  padding: var(--d-spacing-double);
}

.feedback-header-title {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  padding-top: var(--d-spacing-single);
}

.feedback-header-subtitle {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  padding-top: var(--d-spacing-half);
}

.feedback-header-close-x-icon {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  height: 28px;
  width: 28px;
}`, "",{"version":3,"sources":["webpack://./src/app/chatbot/buddy/buddy-dislike-feedback/buddy-dislike-feedback.component.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,UAAA;AADJ;;AAIA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AADJ;;AAIA;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kFAAA;AADJ;;AAIA;EACI,gCAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;AADJ;;AAIA;EACI,+CAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;AADJ;;AAIA;EACI,gCAAA;AADJ;;AAIA;EC1CI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDyCA,oCAAA;AAEJ;;AACA;ECxCI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDuCA,kCAAA;AAKJ;;AAFA;ECpDI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDmDA,YAAA;EACA,WAAA;AAQJ","sourcesContent":["@import 'src/mixins.scss';\n\nion-grid {\n    width: 100%;\n    padding: 0;\n}\n\n.chatbot-dislike-feedback-content {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-flow: column;\n}\n\n.feedback-flag-selection {\n    display: flex;\n    flex-flow: column;\n    width: 100%;\n    background-color: var(--ion-color-tertiary);\n    overflow-y: scroll;\n    overflow-x: hidden;\n    flex-grow: 1;\n    padding: var(--d-spacing-single) var(--d-spacing-double) 0 var(--d-spacing-double);\n}\n\n.feedback-dislike-buttons {\n    padding: var(--d-spacing-double);\n    padding-top: var(--d-spacing-single);\n    box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.25);\n    z-index: 10000;\n}\n\n.feedback-header-content {\n    min-height: calc(var(--d-spacing-double) * 2.5);\n    width: 100%;\n    margin: 0;\n    background-color: white;\n}\n\n.feedback-header-content-container {\n    padding: var(--d-spacing-double);\n}\n\n.feedback-header-title {\n    @include h1-style;\n    padding-top: var(--d-spacing-single);\n}\n\n.feedback-header-subtitle {\n    @include p1-style;\n    padding-top: var(--d-spacing-half);\n}\n\n.feedback-header-close-x-icon {\n    @include h1-style;\n    height: 28px;\n    width: 28px;\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
